export const relevantCategoryData = [
  { SubTypes: 'poster-ratio-11x7', Classes: null, URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'sale-poster', URL: '/templates/posters/sale' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'event-poster', URL: '/templates/posters/event' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'back-to-shcool', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'business', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'advertising', URL: '/templates/posters/advertising' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'school', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'campaign', URL: '/templates/posters' },
  {
    SubTypes: 'poster-ratio-11x7',
    Classes: 'motivational',
    URL: '/templates/posters/motivational',
  },
  { SubTypes: 'poster-ratio-11x7', Classes: 'music', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'climate-change', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'concert', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'movie', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'birthday', URL: '/templates/posters/birthday' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'graduation', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'congratulation', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'wanted', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'gym', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'sports', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'mental-health', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'festival', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'conference', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'science-fair-poster', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'floral', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'kids', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'fundraising', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'dance', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'beauty', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'breast-cancer-awareness', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'sceintific', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'anti-bullying', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: "women's-rights", URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'research', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'animal-rights', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'prom', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'holiday', URL: '/templates/posters/holiday' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'college', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'alcohol-awareness', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'vintage', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'car-wash', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'human-rights', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'thanksgiving', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'domestic-violence', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'christmas', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'chinese-new-year', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'earth-day', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'election', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'halloween', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'diwali', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'educational', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'club', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: "mother's-day", URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'church', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'recycling', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'recruitment', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: 'safety', URL: '/templates/posters' },
  { SubTypes: 'poster-ratio-11x7', Classes: "valentine's-day", URL: '/templates/posters' },
  { SubTypes: 'greeting-cards', Classes: null, URL: '/templates/greeting-cards' },
  { SubTypes: 'busniess-cards-ratio-1050x600', Classes: null, URL: '/templates/business-cards' },
  {
    SubTypes: 'busniess-cards-ratio-1050x600',
    Classes: 'photography',
    URL: '/templates/business-cards',
  },
  { SubTypes: 'busniess-cards-ratio-1050x601', Classes: 'music', URL: '/templates/business-cards' },
  { SubTypes: 'busniess-cards-ratio-1050x602', Classes: 'dj', URL: '/templates/business-cards' },
  {
    SubTypes: 'busniess-cards-ratio-1050x603',
    Classes: 'catering',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x604',
    Classes: 'teacher',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x605',
    Classes: 'landscaping',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x606',
    Classes: 'hair-salon',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x607',
    Classes: 'bakery',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x608',
    Classes: 'vintage',
    URL: '/templates/business-cards',
  },
  { SubTypes: 'busniess-cards-ratio-1050x609', Classes: 'cute', URL: '/templates/business-cards' },
  {
    SubTypes: 'busniess-cards-ratio-1050x610',
    Classes: 'fashion',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x611',
    Classes: 'fitness',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x612',
    Classes: 'dental',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x613',
    Classes: 'barber',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x614',
    Classes: 'massage-therapist',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x615',
    Classes: 'roofing',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x616',
    Classes: 'restaurant',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x617',
    Classes: 'tattoo',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x618',
    Classes: 'makeup-artist',
    URL: '/templates/business-cards',
  },
  { SubTypes: 'busniess-cards-ratio-1050x619', Classes: 'cake', URL: '/templates/business-cards' },
  {
    SubTypes: 'busniess-cards-ratio-1050x620',
    Classes: 'personal',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x621',
    Classes: 'painter',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x622',
    Classes: 'electrician',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x623',
    Classes: 'professional',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x624',
    Classes: 'personal-trainer',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x625',
    Classes: 'real-estate',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x626',
    Classes: 'artist',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x627',
    Classes: 'corporate',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x628',
    Classes: 'designer',
    URL: '/templates/business-cards',
  },
  { SubTypes: 'busniess-cards-ratio-1050x629', Classes: 'black', URL: '/templates/business-cards' },
  {
    SubTypes: 'busniess-cards-ratio-1050x630',
    Classes: 'creative',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x631',
    Classes: 'simple',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x632',
    Classes: 'plumbing',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x633',
    Classes: 'mechanic',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x634',
    Classes: 'cleaning',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x635',
    Classes: 'modern',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x636',
    Classes: 'interior-designer',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x637',
    Classes: 'graphic-design',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x638',
    Classes: 'luxury',
    URL: '/templates/business-cards',
  },
  { SubTypes: 'busniess-cards-ratio-1050x639', Classes: 'photo', URL: '/templates/business-cards' },
  {
    SubTypes: 'busniess-cards-ratio-1050x640',
    Classes: 'medical',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x641',
    Classes: 'event-planner',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x642',
    Classes: 'contractor',
    URL: '/templates/business-cards',
  },
  {
    SubTypes: 'busniess-cards-ratio-1050x643',
    Classes: 'florist',
    URL: '/templates/business-cards',
  },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: null, URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'event', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'marketing', URL: '/templates/flyers/marketing' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'business', URL: '/templates/flyers/business' },
  {
    SubTypes: 'flyers-ratio-8.5-x-11',
    Classes: 'real-estate',
    URL: '/templates/flyers/real-estate',
  },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'sale', URL: '/templates/flyers/sale' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'church', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'party', URL: '/templates/flyers/party' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'restaurant', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'club', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'advertising', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'birthday', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'summer-camp', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'halloween', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'volunteer', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'music', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'fitness', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'art', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'grand-opening', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'happy-hour', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'hair-salon', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'yard-sale', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'dance', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'bake-sale', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'babysitting', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'cleaning', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'tutor', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'landscaping', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'construction', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'talent-show', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'car-wash', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'daycare', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'thanksgiving', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'christmas', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'school', URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: "valentine's-day", URL: '/templates/flyers' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'education', URL: '/templates/flyers/education' },
  { SubTypes: 'flyers-ratio-8.5-x-11', Classes: 'black-friday', URL: '/templates/flyers' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: null, URL: '/templates/invitations' },
  {
    SubTypes: 'invitations-ratio-5-x-7',
    Classes: 'holiday',
    URL: '/templates/invitations/holiday',
  },
  {
    SubTypes: 'invitations-ratio-5-x-7',
    Classes: 'christmas',
    URL: '/templates/invitations/christmas',
  },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'thanksgiving', URL: '/templates/invitations' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'diwali', URL: '/templates/invitations' },
  {
    SubTypes: 'invitations-ratio-5-x-7',
    Classes: 'birthday',
    URL: '/templates/invitations/birthday',
  },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'party', URL: '/templates/invitations/party' },
  {
    SubTypes: 'invitations-ratio-5-x-7',
    Classes: 'baby-shower',
    URL: '/templates/invitations/baby-shower ',
  },
  {
    SubTypes: 'invitations-ratio-5-x-7',
    Classes: 'graduation',
    URL: '/templates/invitations/graduation',
  },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'quinceanera', URL: '/templates/invitations' },
  {
    SubTypes: 'invitations-ratio-5-x-7',
    Classes: 'housewarming',
    URL: '/templates/invitations/housewarming',
  },
  {
    SubTypes: 'invitations-ratio-5-x-7',
    Classes: 'wedding',
    URL: '/templates/invitations/wedding',
  },
  {
    SubTypes: 'invitations-ratio-5-x-7',
    Classes: 'bridal-shower',
    URL: '/templates/invitations/bridal-shower',
  },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'open-house', URL: '/templates/invitations' },
  {
    SubTypes: 'invitations-ratio-5-x-7',
    Classes: 'rehearsal-dinner',
    URL: '/templates/invitations',
  },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'movie-night', URL: '/templates/invitations' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'sweet-16', URL: '/templates/invitations' },
  {
    SubTypes: 'invitations-ratio-5-x-7',
    Classes: 'baptism',
    URL: '/templates/invitations/baptism',
  },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'gala', URL: '/templates/invitations' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'picnic', URL: '/templates/invitations' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'breakfast', URL: '/templates/invitations' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'church', URL: '/templates/invitations/church' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'travel', URL: '/templates/invitations' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'brunch', URL: '/templates/invitations' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'luncheon', URL: '/templates/invitations' },
  {
    SubTypes: 'invitations-ratio-5-x-7',
    Classes: '50th-anniversary',
    URL: '/templates/invitations',
  },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'bowling', URL: '/templates/invitations' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'wine-tasting', URL: '/templates/invitations' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'masquerade', URL: '/templates/invitations' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'happy-hour', URL: '/templates/invitations' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'groomsman', URL: '/templates/invitations' },
  {
    SubTypes: 'invitations-ratio-5-x-7',
    Classes: 'first-communion',
    URL: '/templates/invitations',
  },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'get-together', URL: '/templates/invitations' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'sleepover', URL: '/templates/invitations' },
  { SubTypes: 'invitations-ratio-5-x-7', Classes: 'halloween', URL: '/templates/invitations' },
  {
    SubTypes: 'gifrt-certificates-2400-x-1125',
    Classes: null,
    URL: '/templates/gift-certificates',
  },
  {
    SubTypes: 'gifrt-certificates-2400-x-1126',
    Classes: 'massage',
    URL: '/templates/gift-certificates',
  },
  {
    SubTypes: 'gifrt-certificates-2400-x-1127',
    Classes: "mother's-day",
    URL: '/templates/gift-certificates',
  },
  {
    SubTypes: 'gifrt-certificates-2400-x-1128',
    Classes: 'restaurant',
    URL: '/templates/gift-certificates',
  },
  {
    SubTypes: 'gifrt-certificates-2400-x-1129',
    Classes: 'photography',
    URL: '/templates/gift-certificates',
  },
  {
    SubTypes: 'gifrt-certificates-2400-x-1130',
    Classes: 'christmas',
    URL: '/templates/gift-certificates',
  },
  { SubTypes: 'logos-ratio-800-x-800', Classes: null, URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'hospital', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'doctor', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'church', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'event', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'animated', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'gaming', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'badge', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'art', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'fashion', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'band', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'computer', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'food/drink', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'education', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'sports', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'restaurant', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'coffee', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'dj', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'beauty', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'basketball', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'law', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'automotive', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'circular', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'real-estate', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'typography', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'heart', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'plant', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'family', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'car-wash', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'pharmacy', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'music', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'business', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'service', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'finance', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'gym', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'health', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'hotel', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'minimalist', URL: '/templates/logos' },
  { SubTypes: 'logos-ratio-800-x-800', Classes: 'farm', URL: '/templates/logos' },
  { SubTypes: 'desktop-wallpapers-1600-x900', Classes: null, URL: '/templates/desktop-wallpapers' },
  {
    SubTypes: 'desktop-wallpapers-1600-x900',
    Classes: 'beach',
    URL: '/templates/desktop-wallpapers',
  },
  {
    SubTypes: 'desktop-wallpapers-1600-x900',
    Classes: 'motivational',
    URL: '/templates/desktop-wallpapers',
  },
  {
    SubTypes: 'desktop-wallpapers-1600-x900',
    Classes: 'cute',
    URL: '/templates/desktop-wallpapers',
  },
  {
    SubTypes: 'desktop-wallpapers-1600-x900',
    Classes: 'nature',
    URL: '/templates/desktop-wallpapers',
  },
  {
    SubTypes: 'desktop-wallpapers-1600-x900',
    Classes: 'floral',
    URL: '/templates/desktop-wallpapers',
  },
  {
    SubTypes: 'desktop-wallpapers-1600-x900',
    Classes: 'retro',
    URL: '/templates/desktop-wallpapers',
  },
  {
    SubTypes: 'desktop-wallpapers-1600-x900',
    Classes: 'spring',
    URL: '/templates/desktop-wallpapers',
  },
  {
    SubTypes: 'desktop-wallpapers-1600-x900',
    Classes: 'minimalist',
    URL: '/templates/desktop-wallpapers',
  },
  {
    SubTypes: 'desktop-wallpapers-1600-x900',
    Classes: 'funny',
    URL: '/templates/desktop-wallpapers',
  },
  {
    SubTypes: 'desktop-wallpapers-1600-x900',
    Classes: 'creative',
    URL: '/templates/desktop-wallpapers',
  },
  {
    SubTypes: 'desktop-wallpapers-1600-x900',
    Classes: 'summer',
    URL: '/templates/desktop-wallpapers',
  },
  {
    SubTypes: 'desktop-wallpapers-1600-x900',
    Classes: 'halloween',
    URL: '/templates/desktop-wallpapers',
  },
  {
    SubTypes: 'desktop-wallpapers-1600-x900',
    Classes: 'thanksgiving',
    URL: '/templates/desktop-wallpapers',
  },
  {
    SubTypes: 'desktop-wallpapers-1600-x900',
    Classes: 'organizer',
    URL: '/templates/desktop-wallpapers',
  },
  { SubTypes: 't-shirts-(4200x-5400)', Classes: null, URL: '/templates/t-shirts' },
  { SubTypes: 'postcards-1050-x-1500', Classes: null, URL: '/templates/postcards' },
  { SubTypes: 'postcards-1050-x-1501', Classes: 'save-the-date', URL: '/templates/postcards' },
  { SubTypes: 'postcards-1050-x-1502', Classes: 'real-estate', URL: '/templates/postcards' },
  { SubTypes: 'postcards-1050-x-1503', Classes: 'thank-you', URL: '/templates/postcards' },
  { SubTypes: 'postcards-1050-x-1504', Classes: 'holiday', URL: '/templates/postcards' },
  { SubTypes: 'postcards-1050-x-1505', Classes: 'business', URL: '/templates/postcards' },
  { SubTypes: 'postcards-1050-x-1506', Classes: 'travel', URL: '/templates/postcards' },
  { SubTypes: 'postcards-1050-x-1507', Classes: 'art', URL: '/templates/postcards' },
  { SubTypes: 'postcards-1050-x-1508', Classes: 'marketing', URL: '/templates/postcards' },
  { SubTypes: 'postcards-1050-x-1509', Classes: 'birthday', URL: '/templates/postcards' },
  { SubTypes: 'postcards-1050-x-1510', Classes: 'vintage', URL: '/templates/postcards' },
  { SubTypes: 'postcards-1050-x-1511', Classes: 'french', URL: '/templates/postcards' },
  { SubTypes: 'postcards-1050-x-1512', Classes: 'funny', URL: '/templates/postcards' },
  { SubTypes: 'postcards-1050-x-1513', Classes: 'christmas', URL: '/templates/postcards' },
  { SubTypes: 'instagram-templates', Classes: null, URL: '/templates/instagram' },
  {
    SubTypes: 'instagram-templates',
    Classes: 'instagram-story',
    URL: '/templates/instagram/stories',
  },
  { SubTypes: 'instagram-templates', Classes: 'instagram-post', URL: '/templates/instagram/posts' },
  { SubTypes: 'facebook-templates', Classes: null, URL: '/templates/facebook' },
  { SubTypes: 'facebook-templates', Classes: 'facebook-cover', URL: '/templates/facebook/covers' },
  { SubTypes: 'facebook-templates', Classes: 'facebook-post', URL: '/templates/facebook/posts' },
  { SubTypes: 'facebook-templates', Classes: 'facebook-ad', URL: '/templates/facebook/ads' },
  { SubTypes: 'facebook-templates', Classes: 'facebook-story', URL: '/templates/facebook/stories' },
  {
    SubTypes: 'facebook-templates',
    Classes: 'facebook-event',
    URL: '/templates/facebook/event-covers',
  },
  {
    SubTypes: 'facebook-templates',
    Classes: 'facebook-story-templates',
    URL: '/templates/facebook',
  },
  { SubTypes: 'youtube-templates', Classes: null, URL: '/templates/youtube' },
  { SubTypes: null, Classes: 'youtube-channel-art', URL: '/templates/youtube/channel-art' },
  { SubTypes: 'youtube-templates', Classes: null, URL: null },
  {
    SubTypes: 'youtube-templates',
    Classes: 'youtube-thumbnail',
    URL: '/templates/youtube/thumbnails',
  },
  {
    SubTypes: 'youtube-templates',
    Classes: 'youtube-end-screen',
    URL: '/templates/youtube/end-screens',
  },
  {
    SubTypes: 'youtube-templates',
    Classes: 'youtube-profile-picture',
    URL: '/templates/youtube/profile-pictures',
  },
  { SubTypes: 'twitter', Classes: null, URL: '/templates/twitter' },
  { SubTypes: 'twitter', Classes: 'twitter-header', URL: '/templates/twitter/headers' },
  { SubTypes: 'twitter', Classes: 'twitter-post', URL: '/templates/twitter/posts' },
  { SubTypes: null, Classes: 'twitter-profile-templates', URL: '/templates/twitter' },
  { SubTypes: 'pinterest', Classes: null, URL: '/templates/pinterest-pins' },
  { SubTypes: 'linkedin', Classes: null, URL: '/templates/linkedin' },
  { SubTypes: 'linkedin', Classes: 'linkedin-banner', URL: '/templates/linkedin' },
  { SubTypes: 'linkedin', Classes: 'linkedin-post', URL: '/templates/linkedin' },
  { SubTypes: 'letterhead', Classes: null, URL: '/templates/letterheads' },
  { SubTypes: 'twitch', Classes: null, URL: '/templates/twitch' },
  { SubTypes: null, Classes: 'wattpad', URL: '/templates/ebook-covers/wattpad' },
  { SubTypes: 'e-book-cover', Classes: null, URL: '/templates/ebook-covers' },
  { SubTypes: 'e-book-cover', Classes: 'wattpad-cover', URL: '/templates/ebook-covers/wattpad' },
  { SubTypes: 'album-cover', Classes: null, URL: '/templates/album-covers' },
  { SubTypes: 'magazine-cover', Classes: null, URL: '/templates/magazine-covers' },
  { SubTypes: 'brochures', Classes: null, URL: '/templates/brochures' },
  { SubTypes: 'banners', Classes: null, URL: '/templates/banners' },
  { SubTypes: 'annoucements', Classes: null, URL: '/templates/announcements' },
  { SubTypes: 'programs', Classes: null, URL: '/templates/programs' },
  { SubTypes: 'menus', Classes: null, URL: '/templates/menus' },
  { SubTypes: 'mood-boards', Classes: null, URL: '/templates/photo-collages/mood-boards' },
  { SubTypes: 'invoices', Classes: null, URL: '/templates/invoices' },
  { SubTypes: 'blog-banners', Classes: null, URL: '/templates/blog-banners' },
  { SubTypes: 'social-media', Classes: null, URL: '/templates/social-media' },
  { SubTypes: 'etsy-shop', Classes: null, URL: '/templates/etsy-shop-covers' },
  { SubTypes: 'zoom-background', Classes: null, URL: '/templates/zoom-virtual-backgrounds' },
  { SubTypes: 'lesson-plan', Classes: null, URL: '/templates/lesson-plans' },
  { SubTypes: 'meme', Classes: null, URL: '/templates/memes' },
  { SubTypes: 'email-header', Classes: null, URL: '/templates/email-headers' },
  { SubTypes: 'photo-collage', Classes: null, URL: '/templates/photo-collages' },
  { SubTypes: 'storyboard', Classes: null, URL: '/templates/storyboards' },
  { SubTypes: 'table-of-contents', Classes: null, URL: '/templates/table-of-contents' },
];

export const seeMoreText = 'See more';
export const seeLessText = 'See Less';

export const relevantCategoriesText = 'Relevant Categories';

export const commercialTitle = 'commercial';

export const licenseCommercialText =
  'Content under the Commercial tab can be used for promotions, advertising, marketing, and business-related activities intended for generating profit.';

export const licenseNotCommercialText =
  'Content under the Personal tab can be used for personal projects, and is not intended for commercial use.';

export const editNowText = 'Edit now';

export const generateAiTemplates = 'Generate templates with AI';

export const licenseTitle = 'License';

export const sizeText = 'Size';

export const animateStaticTemplates = 'Animate static templates';

export const localizeTemplates = 'Localize your templates';

export const moreLikeThisText = 'More like this';

export const descriptionText = 'Description';

export const loadMoreButtonText = 'Load more';

export const designDetailsText = 'Design details';

export const ANALYTICS_NAMES = {
  GRID_LAYOUT: 'TemplateAsset',
  SLIDER: 'Preview',
  ASIDE: 'InfoBlock',
  EDIT_SHARE_WRAPPER: 'EditNowShare',
  EDIT_BUTTON: 'EditButton',
  SHERE_BUTTON: 'ShereButton',
  SHERE_COPY_BUTTON: 'ShereCopyButton',
  COPY_BUTTON: 'CopyButton',
  RELEVANT_CATEGORIES: 'RelevantCategories',
  RELEVANT_CATEGORY_BUTTON: 'RelevantCategoryButton',
  RELEVANT_CATEGORIES_SEE_BUTTON: 'RelevantCategoriesSeeButton',
  CONTENT: 'SimilarTemplates ',
  LOAD_MORE: 'LoadMore',
  TEMPLATE_SHARE_BUTTON: 'TemplateShareButton',
  DESCRIPTION_SEE_BUTTON: 'DescriptionSeeButton',
};

export const generateAiTemplatesUrl = (templateId: number) =>
  `/create/editor?category=miniapps&app=com.picsart.ai.template.generator&template=${templateId}`;

export const generateAnimateStaticTemplatesUrl = `/image-to-video/`;

export const generateLocalizeTemplatesUrl = (templateId: number) =>
  `/create/editor?category=miniapps&app=com.picsart.bulk.localization&template=${templateId}`;
